// What covers Misti's face until she can actually hold a conversation.
//
//   tap      the play button - browsers grant the mic only after a user gesture
//   waking   the assistant call is connecting, then the wake word is loading
//            (its models take a while on the first load)
//   leaving  both are up: the blur fades away and her face comes through
//
// The face runs underneath the whole time, so it is already awake and moving
// when the blur lifts.

import React from "react";

const STEPS = {
	voice: { title: "Waking up", detail: "Connecting her voice" },
	ears: { title: "Getting ready", detail: "Tuning her ears for “Hey Misti”" },
	error: { title: "Waking up", detail: "Can’t reach the assistant yet – still trying" },
};

const BootOverlay = ({ phase, step = "voice", slow = false, onStart, onSkip }) => {
	const s = STEPS[step] || STEPS.voice;
	return (
		<div className={`boot-overlay is-${phase}`}>
			{phase === "tap" ? (
				<button onClick={onStart} className="enable-audio-button" aria-label="Start Misti">
					{/* Drawn so the triangle's optical centre - halfway between its
					    box centre and its centroid - sits on the circle's centre. */}
					<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
						<path d="M7.8 6.5v11a1 1 0 0 0 1.54.84l8.2-5.5a1 1 0 0 0 0-1.68l-8.2-5.5A1 1 0 0 0 7.8 6.5Z" />
					</svg>
				</button>
			) : (
				<div className="boot-status" key={step}>
					<div className="boot-eyes" aria-hidden="true">
						<span />
						<span />
					</div>
					<p className="boot-title" role="status" aria-live="polite">
						{s.title}
						<span className="boot-dots" aria-hidden="true">
							<i>.</i>
							<i>.</i>
							<i>.</i>
						</span>
					</p>
					<p className="boot-detail">{s.detail}</p>
					{slow && (
						<button className="boot-skip" onClick={onSkip}>
							Show Misti now
						</button>
					)}
				</div>
			)}
		</div>
	);
};

export default BootOverlay;
